import { constants, actions } from 'ducks-helpers';

//  SUFFIXES
// [
//   'LOADING',
//   'PENDING',
//   'SUCCESS',
//   'ERROR',
//   'FAILED',
//   'CANCELED'
// ]

export const TYPE = constants('reports/prices', [
    '~FETCH_PRICES',
    'EXPORT_TO_EXCEL'
]);

export const ACTION = actions(TYPE);
